import { createContext } from "react";

const EditContactContext = createContext({
    editContactData: {},
    setEditContactData: ({}) => {}
})

export default EditContactContext